var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import PrintIcon from '@material-ui/icons/Print';
import { withStyles } from '@material-ui/core';
const TfoButton = withStyles({
    root: {
        borderRadius: 0,
    }
})(Button);
const PrintButton = (_a) => {
    var { small, text, color } = _a, rest = __rest(_a, ["small", "text", "color"]);
    return (React.createElement(React.Fragment, null,
        small && (React.createElement(IconButton, Object.assign({ color: "primary", component: "span" }, rest, { title: text }),
            React.createElement(PrintIcon, null))),
        !!!small && (React.createElement(TfoButton, Object.assign({ variant: "contained", color: "primary", disableElevation: true, startIcon: React.createElement(PrintIcon, null) }, rest), text || rest.children))));
};
export default PrintButton;
